import React from 'react';
import Report from './report';

const Reports = props => {
    if (!props.reports) return null;
    
    return props.reports.map(report => {
        return (
            <li key={report.reportPath}>
                <Report {...report} {...props} />
            </li>
        );
    });
};

export default Reports;